import { type Position as RawPosition } from "#/services/kyan/kyan.types";
import { type Position } from "#/types/positions";
import { type InstrumentType } from "#/types/trade";
import {
  getOptionInstrumentProperties,
  isOptionInstrument,
} from "#/utils/instrument.utils";

export const transformPositions = (positions: RawPosition[]): Position[] => {
  return positions.map((position) => {
    const isOption = isOptionInstrument(position.instrument);
    const instrumentType = (isOption ? "options" : "perps") as InstrumentType;
    const maturity = isOption
      ? getOptionInstrumentProperties(position.instrument).maturity
      : "";
    const accruedFunding = isOption
      ? NaN
      : Number(position.accrued_funding ?? 0);

    const size = isOption
      ? Number(position.size)
      : Number(position.contracts ?? position.size);
    const avgPrice = Number(position.average_price);
    const markPrice = Number(position.mark_price);

    const value = size * (markPrice - avgPrice) + size;

    return {
      instrument: position.instrument,
      instrumentType,
      maturity,
      size,
      value,
      avgPrice,
      markPrice,
      pnl: (markPrice - avgPrice) * size,
      accruedFunding,
      ...position.position_greeks,
    };
  });
};
